module.exports = "<fd-file-upload\n  title=\"{{ vm.name }}.title\"\n  body=\"{{ vm.name }}.body\"\n  accept-file-types=\"vm.options.acceptFileTypes\"\n  upload-url=\"{{ vm.options.uploadUrl }}\"\n  upload=\"vm.upload(fileId)\"\n  upload-start=\"vm.uploadStart(upload)\"\n  upload-fail=\"vm.uploadFail(err)\"\n  upload-finally=\"vm.uploadFinally()\">\n</fd-file-upload>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-form-control/src/templates/formControl.upload.html
// module id = 1494
// module chunks = 12